import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { UtilService } from 'src/app/util/util.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { CROSS } from 'src/defaultImages.js';
import { FcOrder } from 'src/app/common/enums/print-eventDetails.enum';
declare global {
  interface Window {
    chrome: any;
  }
}

@Component({
  selector: 'app-print-orderdetails',
  templateUrl: './print-orderdetails.component.html',
  styleUrls: ['./print-orderdetails.component.css'],
})
export class PrintOrderdetailsComponent implements OnInit {
  images = {
    CROSS: CROSS,
  };
  Currency;
  allKitchenCounter: any;
  ordersIteration: any;
  allItems: any;
  now: any;
  tableNo: any;
  orderNo: any;
  restaurantName: string;
  rest_address: string;
  currentOrderItems: any;
  billTotal: any;
  fees: any;
  order_status: any;
  invoiceObj = {
    data: [],
  };
  rest_id: string;
  currentOrderId: any;
  printData: any;
  dataReady: boolean = false;
  dkick_code: any = undefined;
  printer: any = '';
  isKioskOrder: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<PrintOrderdetailsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private utilService: UtilService,
    private curr: CurrencyService
  ) {
    this.Currency = this.curr.getCurrency();
  }

  ngOnInit() {
    this.getRestDetails();
    this.allKitchenCounter = this.data.allKitchenCounter;
    this.ordersIteration = this.data.itrOrders;
    this.tableNo = this.data.currentTable;
    this.orderNo = this.data.orderNo;
    this.currentOrderItems = this.data.currentOrderItems;
    this.fees = this.data.fee;
    this.billTotal = this.data.total;
    this.order_status = this.data.order_status;
    this.restaurantName = localStorage.getItem('restaurant_name');
    this.rest_address = localStorage.getItem('restaurant_address');
    this.rest_id = localStorage.getItem('restaurant_id');
    this.currentOrderId = this.data.orderid;
    this.isKioskOrder = this.data?.isKioskOrder === FcOrder?.isOrderByKiosk;
  }
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  sortKeysAsNumbers(a, b) {
    return parseInt(a) - parseInt(b);
  }
  getKitchenCounterName(name) {
    if (name === 'default') {
      return 'Unmapped Items';
    } else {
      for (let counter of this.allKitchenCounter) {
        if (counter.kitchen_counter_id == name) {
          return counter.counter_name;
        }
      }
    }
  }

  print(items, counterid, iteration) {
    if (this.utilService.isPrinterEnabled()) {
      this.utilService.sendPrintWithItr(
        this.currentOrderId,
        items,
        counterid,
        iteration
      );
    } else {
      this.assignOrders(items);
      this.getPrintDetails(0, counterid, iteration);
      setTimeout(() => {
        this.printHTML();
      }, 1500);
      this.generateOrderJSON(items, counterid);
    }
  }
  getRestDetails() {
    const formData: any = new FormData();
    formData.append('restaurant_id', localStorage.getItem('restaurant_id'));
    this.apiService.getRestaurantDetails(formData).subscribe((res: any) => {
      if (res.status === 1) {
        try {
          this.dkick_code = res.data.dkick_code;
          this.printer = res.data.printer;
        } catch (error) {}
      }
    });
  }

  getPrintDetails(type, cid, itr) {
    const formData: any = new FormData();
    formData.append('order_id', this.currentOrderId);
    formData.append('type', type);
    formData.append('counter_id', cid);
    formData.append('itr', parseInt(itr));
    this.apiService.getPrintDetail(formData).subscribe((res: any) => {
      if (res.status == 1) {
        this.printData = res.data[0];
      }
    });
  }
  assignOrders(items) {
    this.allItems = items;
    this.now = new Date();
  }

  isChrome() {
    return Boolean(window.chrome);
  }

  printHTML() {
    var prtContent = document.getElementById('table');
    var WinPrint = window.open('', '', 'toolbar=1,scrollbars=1,status=0');
    WinPrint.document.write('<html><head><title>Print Order</title></head>');
    WinPrint.document.write('<html><head>');

    WinPrint.document.write('<title>Invoice</title>');
    WinPrint.document.write(
      '<style type="text/css">body{font-family: arial, sans-serif;font-size:14px;width:75mm}#table{width:75mm}table{margin-top:20px; border-collapse: collapse;width: 100%;}table > tbody > tr > th{padding: 10px 3px; border-top: 1px solid rgba(0, 0, 0, 0.75); border-bottom: 1px solid rgba(0, 0, 0, 0.75);}.rest_details{text-align:center;font-size:12px,width:90%,margin-left:5%}.order_details{font-size:12px}.bold{font-size: 18px;font-weight: 800;}p{margin:0!important}#strid{background-color:red}.border-top{border-top:1px dashed #000}.width10{width:10%}.width15{width:15%}.width25{width:25%}.width50{width:50%}.button{font-size:18px;margin:10%;width:80%;background:green;border-radius:5px;color:#fff}table{margin-top:10px,width:75mm}</style>'
    );
    WinPrint.document.write('</head>');

    WinPrint.document.write('<body>');
    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.write('</body></html>');
    WinPrint.document.close();
    if (this.isChrome()) {
      WinPrint.onload = function () {
        setTimeout(function () {
          WinPrint.focus();
          WinPrint.print();
          WinPrint.close();
        }, 200);
      };
    } else {
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
  }

  printFinalBill() {
    if (this.utilService.isPrinterEnabled()) {
      // if(this.utilService.isValidJson(localStorage.getItem('dkick_code'))){
      //   this.utilService.openCashDrawer();
      //   setTimeout(() => {
      //     this.utilService.sendFinalPrintCommand(this.currentOrderId);
      //   }, 1500);
      // } else {
      //   this.utilService.sendFinalPrintCommand(this.currentOrderId);
      // }
      this.utilService.sendFinalPrintCommand(this.currentOrderId);
    } else {
      this.getPrintDetails(1, '', 1);
      setTimeout(() => {
        this.printFinalBillHTML();
      }, 1500);
    }
  }
  printMasterDocket() {
    if (this.utilService.isPrinterEnabled()) {
      this.utilService.sendFinalPrintMasterDocket(this.currentOrderId);
    }
  }
  masterDocketEnabled() {
    if (this.utilService.masterDocketEnabled()) {
      return true;
    } else {
      return false;
    }
  }

  isNumber(val) {
    return typeof val === 'number';
  }

  printFinalBillHTML() {
    var finalBill = document.getElementById('finalBill');
    var WinPrint = window.open('', '', 'toolbar=1,scrollbars=1,status=0');
    WinPrint.document.write('<html><head><title>Print Order</title></head>');
    WinPrint.document.write('<html><head>');

    WinPrint.document.write('<title>Invoice</title>');
    WinPrint.document.write(
      '<style type="text/css">body{font-family: arial, sans-serif;font-size:14px;width:75mm}#finalBill{width:75mm}table{margin-top:20px; border-collapse: collapse;width: 100%;}table > tbody > tr > th{padding: 10px 3px; border-top: 1px solid rgba(0, 0, 0, 0.75); border-bottom: 1px solid rgba(0, 0, 0, 0.75) ;}.rest_details{text-align:center;font-size:12px,width:90%,margin-left:5%}.order_details{font-size:12px}.bold{font-weight:700}p{margin:0!important}#strid{background-color:red}.border-top{border-top:1px dashed #000}.width10{width:10%}.width15{width:15%}.width25{width:25%}.width50{width:50%}.button{font-size:18px;margin:10%;width:80%;background:green;border-radius:5px;color:#fff}table{margin-top:10px}.total-fee{text-align:right}</style>'
    );
    WinPrint.document.write('</head>');

    WinPrint.document.write('<body>');
    WinPrint.document.write(finalBill.innerHTML);
    WinPrint.document.write('</body></html>');
    WinPrint.document.close();

    if (this.isChrome()) {
      WinPrint.onload = function () {
        setTimeout(function () {
          WinPrint.focus();
          WinPrint.print();
          WinPrint.close();
        }, 200);
      };
    } else {
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
    this.generateFinalBillJSON();
  }

  generateFinalBillJSON() {
    let obj = {
      type: 'receipt',
      printerName: 'Cashier',
      header: [],
      body: {
        Table: '',
        Invoice_No: '',
        Date: '',
        Cashier: '',
      },
      order: {
        currency: this.Currency,
        items: [],
        bill: [],
      },
    };

    obj.header.push(this.restaurantName, this.rest_address);
    obj.body.Table = this.tableNo;
    obj.body.Invoice_No = this.orderNo;
    obj.body.Date = new Date().toDateString();
    obj.body.Cashier = 'Manoj';

    this.currentOrderItems.forEach((item) => {
      let itemObj = {
        name: item.itemname,
        qty: item.itemquantity,
        price: item.itemprice,
        amount: item.itemquantity * item.itemprice,
        variants: item.itemVariations,
        addons: item.itemAddons,
      };
      obj.order.items.push(itemObj);
    });

    this.fees.forEach((item) => {
      let feeObj = {
        name: item.name,
        value: item.fee,
      };

      obj.order.bill.push(feeObj);
    });

    return obj;
  }

  generateOrderJSON(itemList, counter_id) {
    let obj = {
      type: 'counter',
      printerName: itemList[0].itemPrinter,
      counterName: '',
      body: {
        Table: '',
        Invoice_No: '',
      },
      items: [],
    };
    obj.counterName = this.getKitchenCounterName(counter_id);
    obj.body.Table = this.tableNo;
    obj.body.Invoice_No = this.orderNo;

    itemList.forEach((item) => {
      let itemObj = {
        name: item.itemname,
        qty: item.itemquantity,
        variants: item.itemVariations,
        addons: item.itemAddons,
      };
      obj.items.push(itemObj);
    });
    return obj;
  }

  generateBulkOrderRecipt() {
    for (const item in this.ordersIteration) {
      for (const x in this.ordersIteration[item]) {
        let invoice = this.generateOrderJSON(this.ordersIteration[item][x], x);
        this.invoiceObj.data.push(invoice);
      }
    }
  }
}
